import { stringify } from 'query-string';

import Logger from 'wanderu-logger';
import { WapiService } from 'wanderu-service-wapi';

const logger = Logger.getLogger('currencyApiService');

async function getSupportedCurrencies() {
    const response = await WapiService.get('currency/supported.json');
    return response.result;
}

async function getConversionRates(fromCurrency, toCurrencies) {
    const qs = {
        code_from: fromCurrency,
        code_to: toCurrencies.join(','),
    };

    const response = await WapiService.get(`currency/exchangerates.json?${stringify(qs)}`);
    const rates = response.result.rates;
    const noRatesExist = Object.values(rates).every((rate) => {
        return !rate;
    });

    if (noRatesExist) {
        let errorMessage = `${fromCurrency} is not a valid/supported currency`;
        logger.error(errorMessage);
        throw new Error(errorMessage);
    }

    return rates;
}

export { getConversionRates };
export { getSupportedCurrencies };

export default {
    getSupportedCurrencies,
    getConversionRates,
};
